// Client-side fetch for /api/lyrics (see src/routes/api.js and
// src/services/lyricsService.js) - the same LRCLIB-backed synced-lyrics
// lookup the now-playing page's karaoke feature already uses. Mirrors
// track-features-client.js's role: a plain async function scene-manager.js
// calls on track change, feeding lyric-hook.js's repeated-phrase analysis.
//
// Never throws - a lookup failure (network, no synced lyrics for this
// track, etc.) resolves to found:false so the caller can just skip the
// lyric-flash effect for that track, same "silently do nothing" contract
// the karaoke mic button already relies on.
import { API_BASE } from './api-base.js';

export function fetchLyrics(title, artist, duration) {
  let url = API_BASE + '/api/lyrics?title=' + encodeURIComponent(title || '') + '&artist=' + encodeURIComponent(artist || '');
  if (typeof duration === 'number' && duration > 0) url += '&duration=' + duration;
  return fetch(url)
    .then(function (res) { return res.json(); })
    .catch(function () { return { found: false, lines: [] }; });
}
